(function(){
"use strict";

angular.module("swapick")
.factory('Filters', Filters);

function Filters(store){
  var svc = {}

  
  svc.getFilter = function(key){
      let currentFilters = store.get("swapick.filters");;
      if (!angular.isObject(currentFilters)){
        currentFilters = {}
      }
      return currentFilters[key];
      
  };

  svc.setFilter = function(key, value){
      let currentFilters = store.get("swapick.filters");
      if (!angular.isObject(currentFilters)){
        currentFilters = {}
      }
      currentFilters[key] = value;
      return store.set("swapick.filters", currentFilters);
  };

  svc.removeAllFilters = function(){
    return store.remove("swapick.filters");   
  };

  svc.removeFilter = function(key){
    let currentFilters = store.get("swapick.filters");
    if (!angular.isObject(currentFilters)){
      currentFilters = {}
    }
    delete currentFilters[key];
    return store.set("swapick.filters", currentFilters);
    
  };


  return svc;    
}



})();


// WEBPACK FOOTER //
// ./src/services/filters-service.js